<template>
  <BaseSelect v-model="categorySlug" class="select-secondary">
    <option value="">
      {{ placeholder }}
    </option>
    <option
      v-for="category in allCategories"
      :key="category.id"
      :value="category.slug"
      :selected="category.slug === categorySlug"
    >
      {{ category.name }}
    </option>
  </BaseSelect>
</template>

<script setup lang="ts">
import { useCategoriesQuery, useCategoryQuery } from "~/graphql/generated";

const props = defineProps<{
  modelValue?: string; // The category Id
  placeholder: string;
}>();

const emit = defineEmits(["update:modelValue"]);
const categorySlug = useVModel(props, "modelValue", emit);

const { data } = await useCategoriesQuery({});

// Check if the current slug is in the list of categories
// If not, it is a disabled category and we need to fetch it and add it to the list
const variables = computed(() => {
  return {
    categoryInput: {
      id: categorySlug.value!,
    },
    pause: computed(() => !categorySlug.value),
  };
});

const { data: chosenCategory } = await useCategoryQuery({
  variables,
});

const allCategories = computed(() => {
  if (chosenCategory.value && chosenCategory.value.category) {
    const allCategories = [
      ...(data.value?.categories ?? []),
      chosenCategory.value.category,
    ];

    // Filter out duplicates by id
    return allCategories.filter(
      (category, index, self) =>
        self.findIndex((c) => c.id === category.id) === index
    );
  }
  return data.value?.categories ?? [];
});
</script>
